var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { AchooInputComponent } from '../achoo-input/achoo-input.component';
import { ValidationHandlerService } from '../validation-handler.service';
import { StringUtils } from '../../utils/string.utils';
var AchooCheckboxComponent = /** @class */ (function (_super) {
    __extends(AchooCheckboxComponent, _super);
    function AchooCheckboxComponent(validationHandlerService) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.validationHandlerService = validationHandlerService;
        _this.selectEvent = new EventEmitter();
        return _this;
    }
    AchooCheckboxComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    AchooCheckboxComponent.prototype.onSelect = function (e) {
        this.selectEvent.emit(e);
    };
    AchooCheckboxComponent.prototype.haveLabel = function () {
        return this.label && StringUtils.trim(this.label) !== '';
    };
    return AchooCheckboxComponent;
}(AchooInputComponent));
export { AchooCheckboxComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-checkbox/achoo-checkbox.component.ts.pre-build-optimizer.js